import React, { useState ,useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { injectModels } from "../../redux/injectModels";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";

const ViewSession = ({props,id,isOpen,closeModal}) => {
  // Sample data for demonstration
  // const { session_id} = useParams(); 

  const navigate=useNavigate();
  const [data,setData]=useState("");
  const sessionDetails = {
    sessionName: data.title,
    jobProfile: data.job_profile,
    company:data.company_name,
    interviewer: data.client,
    interviewee: data.user,
    topic: data.topic
  };

  useEffect(()=>{
    getViewSession()

  },[])
  
  const getViewSession =async()=>{  
    props.application.setLoading(true);
        try {
          const res = await props.admin.viewSession(id);
          if (res.user) {
            setData(res && res.user);
            props.application.setLoading(false);
          } else {
            props.application.setLoading(false);
          }
        } catch (error) {
          props.application.setLoading(false);
        }
  }

  const handleClick =()=>{
    closeModal();
    navigate("/session");
  }
  return ( 
    <Modal
    show={isOpen}
    onHide={closeModal}
    size="md"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <Modal.Header closeButton>
      <Modal.Title>Session Details</Modal.Title>
    </Modal.Header>
    <Modal.Body>
    
    
       <table className="table session_deatils_demo">
         <tbody>
           <tr>
             <th>Title:</th>
             <td>{sessionDetails.sessionName}</td>
           </tr>
           <tr>
             <th>Job Profile:</th>
             <td>{sessionDetails.jobProfile}</td>
           </tr>
           <tr>
           <th>Company Name :</th>
           <td>{sessionDetails.company}</td>
         </tr>
           <tr>
             <th>Interviewer:</th>
             <td>{sessionDetails.interviewer}</td>
           </tr>
           <tr>
             <th>Interviewee:</th>
             <td>{sessionDetails.interviewee}</td>
           </tr>
           <tr>
             <th>Topic:</th>
             <td>{sessionDetails.topic}</td>
           </tr>
         </tbody>
       </table>
       <div
       style={{
         display: "flex",
         justifyContent: "end",
         alignItems: "center",
       }}
     >
     
       <button className="btn btn-secondary" style={{ marginTop: '20px' }} onClick={handleClick}>Back</button>
     </div>
    </Modal.Body>
  </Modal>
  );
}

export default injectModels(["admin", "application"])(ViewSession);